import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import DashboardPage from '@/components/pages/dashboard';

const ProtectedDashboard = withAuthenticationRequired(DashboardPage, {
  onRedirecting: () => <Loading />,
});

export const Route = createFileRoute('/dashboard/')({
  head: () => ({
    meta: [{ title: `Dashboard | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedDashboard,
});
